export function getEmails(input) {
  return input
    .split(/[,;\s]+/)
    .filter(Boolean)
    .join(',');
}
